export default __webpack_public_path__ + "static/media/Boots of Fearless Souls.99db9936.jpg";